import {
    registerBowlerChartProduct,
    extractProductSchemaInfo,
    updateProductMetadata,
    getBowlerChartProductDetails,
    deleteBowlerChartProduct,
    updateBowlerChartProduct,
    createMount,
    fetchSavyintReadOnlyGroups,
    createSavyintAddRequest
} from "@/config/apiEndPoints";

// Common function
const createRequest = (method, url, requestData, idToken) => {
    return {
        method, // dynamic (get, post, put, delete...)
        url,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        // Only attach data for non-GET
        ...(method.toLowerCase() !== "get" && { data: requestData }),

        // For GET → use params
        ...(method.toLowerCase() === "get" && { params: requestData }),

        validateStatus(status) {
            return (status >= 200 && status < 300) || status === 400 || status === 500;
        }
    };
};

// API methods
const registerBowlerChartProductDetails = (requestData, idToken) => {
    return createRequest("post", registerBowlerChartProduct, requestData, idToken);
};

const extractProductSchemaInfoDetails = (requestData, idToken) => {
    return createRequest("post", extractProductSchemaInfo, requestData, idToken);
};
const getBowlerChartProductList = (requestData, idToken) => {
    return createRequest("post", getBowlerChartProductDetails, requestData, idToken);
};

// Explicit method name for edit/details use-cases
const getBowlerChartProductDetailsApi = (requestData, idToken) => {
    return createRequest("post", getBowlerChartProductDetails, requestData, idToken);
};
const deleteBowlerChartProductDetails = (requestData, idToken) => {
    return createRequest("post", deleteBowlerChartProduct, requestData, idToken);
};
const updateBowlerChartProductDetails = (requestData, idToken) => {
    return createRequest("post", updateBowlerChartProduct, requestData, idToken);
};
const updateProductMetadataDetails = (requestData, idToken) => {
    return createRequest("post", updateProductMetadata, requestData, idToken);
};
const createMountDetails = (requestData, idToken) => {
    return createRequest("post", createMount, requestData, idToken);
};
const fetchSavyIntReadOnlyGroupsDetails = (requestData, idToken) => {
    return createRequest("get", fetchSavyintReadOnlyGroups, requestData, idToken);
};
const createSavyintAddRequestDetails = (requestData, idToken) => {
    return createRequest("post", createSavyintAddRequest, requestData, idToken);
};
export default {
    registerBowlerChartProductDetails,
    extractProductSchemaInfoDetails,
    getBowlerChartProductList,
    getBowlerChartProductDetails: getBowlerChartProductDetailsApi,
    deleteBowlerChartProductDetails,updateBowlerChartProductDetails,updateProductMetadataDetails,
    createMountDetails,
    fetchSavyIntReadOnlyGroupsDetails,
    createSavyintAddRequestDetails
};
